import { render, staticRenderFns } from "./QuestionTime.vue?vue&type=template&id=84ac68cc&scoped=true&"
import script from "./QuestionTime.vue?vue&type=script&lang=js&"
export * from "./QuestionTime.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTime.vue?vue&type=style&index=0&id=84ac68cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac68cc",
  null
  
)

export default component.exports